module.exports = __webpack_public_path__ + "img/banner_product.60ab2f52.png";